import React,{createRef, forwardRef,useImperativeHandle,useEffect, useState,useRef } from 'react';
import { PrefixName,IdentifyTypeName } from '../../Utils/Prefix';
import { DateThaiFormat } from '../../Utils/Function';
import API from '../../API';

const ApplicationLogView = forwardRef((props,ref) =>{
    const [_LogList,setLogList] = useState([]);
    useEffect(() => {
        (async () => {
            _LoadLogs(props.ApplicationID);
        })();

        return ()=>{ }
    }, []);
    const _LoadLogs = async(ApplicationID)=>{
        setLogList([]);
        API({method : "get",url:"/Application/"+ApplicationID+"/Logs"}).then(res=>{
            setLogList(res.data);
        }).catch(error=>{

        });
    }
    return (
            <>
                <div className='row'>
                    <div className='col-12'>
                        <div className='card'>
                            <div className='card-body'>
                                <div className='table-responsive'>
                                    <table className='table table-bordered table-striped'>
                                        <thead>
                                            <tr>
                                                <th className='text-center' style={{width:"150px"}}>วันที่</th>
                                                <th className='text-center'>Action</th>
                                                <th className='text-center'>รายละเอียด</th>
                                                <th className='text-center'>ชื่อ</th>
                                                <th>หมายเหตุ</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {_LogList.map((v,i)=>(
                                                <tr key={i}>
                                                    <td className='text-center'>{DateThaiFormat(v.Created,true)}</td>
                                                    <td className='text-center'>{v.Action}</td>
                                                    <td>{v.Message}</td>
                                                    <td>{v.Name}</td>
                                                    <td className='text-center'>{v.ClientIP}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    
});

export default React.memo(ApplicationLogView)